export default __webpack_public_path__ + "orders-39dd7c14ffc27ab601a442b8a00d0868.svg";